import App from "./App";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./global.css";

const container = document.getElementById("innovative");

if (container) {
  // Check if React root already exists (React 18 stores it differently)
  if (!container.__reactRoot) {
    const root = createRoot(container);
    container.__reactRoot = root;

    root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    );
  }
}